/**
 * Defines the constants used by the Memos module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 * @author DJ Kim <DJ@thebrandingfarm.com>
 */
export const VUEX_MEMOS_GET_REQUEST                  = 'VUEX_MEMOS_GET_REQUEST'
export const VUEX_MEMOS_GET_SUCCESS                  = 'VUEX_MEMOS_GET_SUCCESS'
export const VUEX_MEMOS_GET_FAILURE                  = 'VUEX_MEMOS_GET_FAILURE'
export const VUEX_MEMOS_SET_APPROVED                 = 'VUEX_MEMOS_SET_APPROVED'
export const VUEX_MEMOS_APPLY_FILTERS                = 'VUEX_MEMOS_APPLY_FILTERS'
export const VUEX_MEMOS_CLEAR_FILTERS                = 'VUEX_MEMOS_CLEAR_FILTERS'
export const VUEX_MEMOS_APPLY_STATUS_FILTER          = 'VUEX_MEMOS_APPLY_STATUS_FILTER'
export const VUEX_MEMOS_APPLY_PROGRESS_FILTER        = 'VUEX_MEMOS_APPLY_PROGRESS_FILTER'
export const VUEX_MEMOS_APPLY_TYPE_FILTER            = 'VUEX_MEMOS_APPLY_TYPE_FILTER'
export const VUEX_MEMOS_APPLY_DEPARTMENT_FILTER      = 'VUEX_MEMOS_APPLY_DEPARTMENT_FILTER'
export const VUEX_MEMOS_APPLY_CREATIVE_ROUND_FILTER  = 'VUEX_MEMOS_APPLY_CREATIVE_ROUND_FILTER'
export const VUEX_MEMOS_SYNC_PAGINATION              = 'VUEX_MEMOS_SYNC_PAGINATION'

export const VUEX_MEMO_GET_REQUEST                   = 'VUEX_MEMO_GET_REQUEST'
export const VUEX_MEMO_GET_SUCCESS                   = 'VUEX_MEMO_GET_SUCCESS'
export const VUEX_MEMO_GET_EVENTS_SUCCESS            = 'VUEX_MEMO_GET_EVENTS_SUCCESS'
export const VUEX_MEMO_GET_FAILURE                   = 'VUEX_MEMO_GET_FAILURE'
export const VUEX_MEMO_UPDATE_INIT                   = 'VUEX_MEMO_UPDATE_INIT'
export const VUEX_MEMO_UPDATE_APPLY_TEMPLATE         = 'VUEX_MEMO_UPDATE_APPLY_TEMPLATE'
export const VUEX_MEMO_UPDATE_PROP                   = 'VUEX_MEMO_UPDATE_PROP'
export const VUEX_MEMO_UPDATE_REQUEST                = 'VUEX_MEMO_UPDATE_REQUEST'
export const VUEX_MEMO_UPDATE_REQUEST_SUCCESS        = 'VUEX_MEMO_UPDATE_REQUEST_SUCCESS' 
export const VUEX_MEMO_UPDATE_REQUEST_FAILURE        = 'VUEX_MEMO_UPDATE_REQUEST_FAILURE'
export const VUEX_MEMO_SAVE_MEMO_NAME                = 'VUEX_MEMO_SAVE_MEMO_NAME'
export const VUEX_MEMO_ADD_EVENT                     = 'VUEX_MEMO_ADD_EVENT'
export const VUEX_MEMO_REMOVE_EVENT                  = 'VUEX_MEMO_REMOVE_EVENT'
export const VUEX_MEMO_TEAM_ADD_MEMBER               = 'VUEX_MEMO_TEAM_ADD_MEMBER'
export const VUEX_MEMO_TEAM_ADD_MEMBER_SUCCESS       = 'VUEX_MEMO_TEAM_ADD_MEMBER_SUCCESS'
export const VUEX_MEMO_TEAM_ADD_MEMBER_FAILURE       = 'VUEX_MEMO_TEAM_ADD_MEMBER_FAILURE'
export const VUEX_MEMO_TEAM_REMOVE_MEMBER            = 'VUEX_MEMO_TEAM_REMOVE_MEMBER'
export const VUEX_MEMO_TEAM_REMOVE_MEMBER_SUCCESS    = 'VUEX_MEMO_TEAM_REMOVE_MEMBER_SUCCESS'
export const VUEX_MEMO_TEAM_REMOVE_MEMBER_FAILURE    = 'VUEX_MEMO_TEAM_REMOVE_MEMBER_FAILURE'

export const VUEX_MEMO_CREATE_INIT                   = 'VUEX_MEMO_CREATE_INIT'
export const VUEX_MEMO_CREATE                        = 'VUEX_MEMO_CREATE'
export const VUEX_MEMO_CREATE_SUCCESS                = 'VUEX_MEMO_CREATE_SUCCESS'
export const VUEX_MEMO_CREATE_FAILURE                = 'VUEX_MEMO_CREATE_FAILURE'
export const VUEX_MEMO_CREATE_UPDATE                 = 'VUEX_MEMO_CREATE_UPDATE'
export const VUEX_MEMO_CREATE_UPDATE_SUCCESS         = 'VUEX_MEMO_CREATE_UPDATE_SUCCESS'
export const VUEX_MEMO_CREATE_UPDATE_FAILURE         = 'VUEX_MEMO_CREATE_UPDATE_FAILURE'
export const VUEX_MEMO_CREATE_APPLY_TEMPLATE         = 'VUEX_MEMO_CREATE_APPLY_TEMPLATE' 
export const VUEX_MEMO_CREATE_UPDATE_PROP            = 'VUEX_MEMO_CREATE_UPDATE_PROP'
export const VUEX_MEMO_CREATE_CANCEL                 = 'VUEX_MEMO_CREATE_CANCEL'
export const VUEX_MEMO_CREATE_CANCEL_PROMPT          = 'VUEX_MEMO_CREATE_CANCEL_PROMPT'
export const VUEX_MEMO_CREATE_HAS_CHANGED            = 'VUEX_MEMO_CREATE_HAS_CHANGED'
export const VUEX_MEMO_CREATE_CLEAR_PROPS_TO_UPDATE  = 'VUEX_MEMO_CREATE_CLEAR_PROPS_TO_UPDATE'

export const VUEX_MEMO_REMOVE                        = 'VUEX_MEMO_REMOVE'
export const VUEX_MEMO_REMOVE_SUCCESS                = 'VUEX_MEMO_REMOVE_SUCCESS'
export const VUEX_MEMO_REMOVE_FAILURE                = 'VUEX_MEMO_REMOVE_FAILURE'

export const VUEX_MEMO_PAGINATION_EXIT               = 'VUEX_MEMO_PAGINATION_EXIT'

export const VUEX_MEMO_ATTACH_FILE                   = 'VUEX_MEMO_ATTACH_FILE'
export const VUEX_MEMO_GET_ATTACHMENTS               = 'VUEX_MEMO_GET_ATTACHMENTS'
export const VUEX_MEMO_GET_ATTACHMENTS_SUCCESS       = 'VUEX_MEMO_GET_ATTACHMENTS_SUCCESS'
export const VUEX_MEMO_REMOVE_FILE                   = 'VUEX_MEMO_REMOVE_FILE'
export const VUEX_MEMO_REMOVE_FILE_SUCCESS           = 'VUEX_MEMO_REMOVE_FILE_SUCCESS'